// Thin localStorage wrapper (JSON-safe) + deviceId helper.
export const storage = {
  get(key, fallback = null) {
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return fallback;
      try { return JSON.parse(raw); } catch { return raw; }
    } catch { return fallback; }
  },
  set(key, value) {
    try { localStorage.setItem(key, typeof value === "string" ? value : JSON.stringify(value)); } catch {}
  },
  remove(key) { try { localStorage.removeItem(key); } catch {} },
};

export function getDeviceId() {
  let id = storage.get("gs_device_id", "");
  if (!id) {
    id = "web_" + (crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now());
    storage.set("gs_device_id", id);
  }
  return id;
}

export const todayKey = () => new Date().toISOString().slice(0, 10);
